import { render, staticRenderFns } from "./MatchingProducts.vue?vue&type=template&id=10f01d2f&scoped=true&"
import script from "./MatchingProducts.vue?vue&type=script&lang=js&"
export * from "./MatchingProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f01d2f",
  null
  
)

export default component.exports